import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Cadastro from './components/Cadastro';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/login/Login';
import Home from './screens/Home/Home';
import UserDashboard from './components/UserDashboard/UserDashboard';
import Contato from './components/Contato';
import Indicadores from './components/Indicadores';
import Planos from './components/Planos';
import Portfolio from './components/Portifolio';
import PublicPageLayout from './components/PublicPageLayout';
import { useAuth } from './components/auth';
import './public-theme.css';

function App() {
  const { isAuthenticated, logout, user } = useAuth();

  const AdminRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'admin'
      ? children
      : <Navigate to="/login" replace />;

  const UserRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'user'
      ? children
      : <Navigate to="/login" replace />;

  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/planos" element={<PublicPageLayout><Planos /></PublicPageLayout>} />
        <Route path="/indicadores" element={<PublicPageLayout><Indicadores /></PublicPageLayout>} />
        <Route path="/portifolio" element={<PublicPageLayout><Portfolio /></PublicPageLayout>} />
        <Route path="/portfolio" element={<Navigate to="/portifolio" replace />} />
        <Route path="/contato" element={<PublicPageLayout><Contato /></PublicPageLayout>} />

        <Route
          path="/dashboard/*"
          element={
            <AdminRoute>
              <Dashboard logout={logout} />
            </AdminRoute>
          }
        />

        <Route
          path="/dashboard-cliente/*"
          element={
            <UserRoute>
              <UserDashboard userId={user?.id} />
            </UserRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
